import React, { Component } from 'react';
import { useContext, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { Modal, FormControl, InputGroup } from 'react-bootstrap';
import { trendingvalidate } from '../../hooks/kycvalidation';
import { deletetrendinghook } from '../../hooks/usebackend';

import proof from "../../images/proof.webp"

class DeleteTrendingModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            deletetrendingModal: true,
            saleaddress: "",
            status: "",
            displayname: "",
            errors: {},
            position: "",
            date: "",
            type: "Launchpad"

        };
    }

    componentDidMount() {
       console.log("props",this.props.data,this.props.data._id) 
    }

   
    handledelete = async () => {

        let payload = {
            id: this.props.data._id
        }

            let settingresult = await deletetrendinghook(payload);
            console.log("trending result",settingresult);
            this.props.getset();
            this.props.onDismiss();
   
    }

    onDismiss=()=> {
        this.setState({ deletetrendingModal: false });
    }



    filterPassedTime = (time) => {
        const currentDate = new Date();
        const selectedDate = new Date(time);
        return currentDate.getTime() < selectedDate.getTime();
    };


    render() {


        const { deletetrendingModal } = this.state


        return (



            <Modal className="wallet-modal edittrend" show={deletetrendingModal} centered size="md">
                <Modal.Header className='pt-3 header_odal_head'>
                    <h3 className="sec-head ">Delete Trending</h3>
                    <button type="button" class="close" onClick={() => this.props.onDismiss()}><span aria-hidden="true">×</span><span class="sr-only">Close</span></button>

                </Modal.Header>
                <Modal.Body className="select-wallet modal_body pt-0 pb-0 px-0">

                    <div className=" px-2">

                        <div className='mod_pad_space pt-0'>
                            <div className='row'>
                                <div className='col-12 col-md-12 px-1 mb-3'>



                                </div>
                                <div className='col-12 col-md-12 px-1 mb-3'>
                                    <p className='input_desc_sm'>Are you sure! You want to delete this trending Sale?</p>  
                                </div>

                              

                                <div className='col-12 col-md-12 px-1 text-center'>
                                    <button className="get-started-btn mt-2" onClick={this.onDismiss}>
                                        Cancel
                                    </button>
                                    <button className="get-started-btn mt-2 ml-3" onClick={this.handledelete}>
                                        Delete
                                    </button>


                                </div>

                                {/* <div className='col-12 col-md-12 px-1 text-center'>
                                    <button className="get-started-btn mt-2" onClick={this.handledelete}>
                                        Delete
                                    </button>

                                </div> */}
                            </div>

                        </div>
                    </div>
                </Modal.Body>
            </Modal>



        )
    }

}


export default DeleteTrendingModal